import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Observable, of } from 'rxjs';
import { catchError, map, take } from 'rxjs/operators';
import { NotificationService } from '../../../../common/services/notification/notification.service';
import { Base } from '../../../../common/models';
import { AddressPlantGateListInitialState, AddressPlantGateListLoad } from './address-plant-gate-list.actions';
import { AddressPlantGateListService } from './address-plant-gate-list.service';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';

export type AddressPlantGateListStateModel = {
  gates: Base[];
  loaded: boolean;
};

const initialState: AddressPlantGateListStateModel = {
  gates: [],
  loaded: false,
};

@State<AddressPlantGateListStateModel>({
  name: 'addressPlantGateList',
  defaults: initialState,
})
@Injectable()
export class AddressPlantGateListState {
  constructor(
    public addressPlantGateListService: AddressPlantGateListService,
    private notificationService: NotificationService,
  ) {}

  @Selector()
  static getLoaded(state: AddressPlantGateListStateModel): boolean {
    return state.loaded;
  }

  @Selector()
  static getList(state: AddressPlantGateListStateModel): Base[] {
    return state.gates;
  }

  @Action(AddressPlantGateListLoad)
  getAddressList(ctx: StateContext<AddressPlantGateListStateModel>): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.addressPlantGateListService.getList().pipe(
      take(1),
      map((gates: Base[]) => ctx.patchState({ gates, loaded: true })),
      catchError(({ error }: HttpErrorResponse) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(AddressPlantGateListInitialState)
  setInitialState(ctx: StateContext<AddressPlantGateListStateModel>): void {
    ctx.setState(initialState);
  }
}
